import { render } from "./Testmonials.vue?vue&type=template&id=23499b0c&scoped=true"
import script from "./Testmonials.vue?vue&type=script&lang=js"
export * from "./Testmonials.vue?vue&type=script&lang=js"

import "./Testmonials.vue?vue&type=style&index=0&id=23499b0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23499b0c"

export default script